//Добавить ещё одного автора.
$(document).on('click', '.add_author', function(){
	var form = $(this).parents(form);
	incube_ajax('feedback', 'html', 'get_new_author', {}, function(response){
		form.find('.authors_cont').append(response);
		$('input.claim_phone').inputmask("+7(999)999-99-99");
	});
});

//Убрать автора.
$(document).on('click', '.remove_author', function(){
	$(this).parents('.one_author').remove();
});

//Отправить форму обращения.
$(document).on('submit', ".feedback_form", function(e){
    e.preventDefault();

    var form = $(this);
    incube_file_ajax('feedback', 'json', 'send_form', new FormData(form[0]), function(response){
    	var claim_block = form.parents('.claim_block');

    	var new_rand = getRandomInt(1000000, 10000000);
	    form[0].rand.value = new_rand;
	    if(form[0].captcha){
	        form[0].captcha.value = '';
	        form.find('.captcha_image').attr('src', '/captcha.php?rand='+new_rand);
	    }

    	if(response['ok']==1){
    		claim_block.find('.form_content').hide();
    		claim_block.find('.suc_text').html(response['message']);
    		claim_block.find('.cf_ok').show();
    	}else{
    		var error_s = '';
            for (var key in response['errors']) {
                error_s+='<div>'+response['errors'][key]+'</div>';
            }
    		claim_block.find('.err_text').html(error_s);
    		claim_block.find('.cf_error').show();
    	}
    });
});